import React from "react";
import MDBox from "components/MDBox";
import Filter from "./components/Filter";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Search from "./components/walletSearch";
function WalletDetails() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        {/* <Filter /> */}
        <Search />
      </MDBox>
    </DashboardLayout>
  );
}

export default WalletDetails;
